import { render, staticRenderFns } from "./Download-app.vue?vue&type=template&id=b1671d82&scoped=true&"
import script from "./Download-app.vue?vue&type=script&lang=ts&"
export * from "./Download-app.vue?vue&type=script&lang=ts&"
import style0 from "./Download-app.vue?vue&type=style&index=0&id=b1671d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1671d82",
  null
  
)

export default component.exports